import { combineReducers } from 'redux';
import user from "./user";
import home from './home';
import appLoader from './appLoader';
import contests from './contests';
import auth from './auth';
import enrollContest from './enrollContest';
import common from './common';
import explore from './explore';
import modal from './modal';
import contestProfile from './contestProfile';
import conformationModal from './conformationModal';
import votingTicketModal from './votingTicketModal';
import socialShareModal from './socialShareModal';
import hostProfile from './hostProfile';
import search from './search';
import voterInfoModal from './voterInfoModal';
import reportModal from './reportModal';
import notification from './notification'
import profileMediaModal from './profileMediaModal';
import singleMedia from './singleMedia';
import imageCropModal from './imageCropModal';

const appReducer = combineReducers({
    user,
    home,
    appLoader,
    contests,
    auth,
    enrollContest,
    common,
    explore,
    contestProfile,
    modal,
    conformationModal,
    votingTicketModal,
    socialShareModal,
    hostProfile,
    search,
    reportModal,
    voterInfoModal,
    notification,
    profileMediaModal,
    singleMedia,
    imageCropModal,
});

const rootReducer = (state, action) => {
    if (action.type === "RESET_APP") {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
